import React, { useEffect, useState, useRef, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SelectCargo from '../../../../../components/Select/SelectCargo';
import SelectPackage from '../../../../../components/Select/SelectPackage';
import SelectLoad from '../../../../../components/Select/SelectLoad';
import TextField from '@material-ui/core/TextField';
import { toEN, formatNumber, rond } from '../../../../../fns';
import SelectAddress from '../../../../../components/Dialog/SelectAddress/SelectAddress';
import moment from 'moment-jalaali';
import { __ } from '../../../../../utils/i18n';
import DatePicker from '../../../../../components/Dialog/LoadingDatePicker';
import FormLabel from '@material-ui/core/FormLabel';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import FleetsTextField from '../../../../../components/TextFields/FleetsTextFields';
import axios from '../../../../../api/axios';
import MainContext from '../../../../../store/MainContext';
import Divider from '@material-ui/core/Divider';
import BriefInfo from '../../../../../components/User/BriefInfo';
import WeightDialog from '../../../../../components/Dialog/WeightDialog/WeightDialog';
import Typography from '@material-ui/core/Typography';
import OrderLogs from './OrderLogs';
// import OrderChats from './OrderChats';
import { useLocation, Link } from 'react-router-dom';
import PriceWithLabel from '../../../../../components/TextFields/PriceWithLabel';
import Drivers from './Drivers/Drivers';
import CommissionsDetails from './CommissionsDetails';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import useRules from '../../../../../hooks/useRules';
import UsersDialog from '../../../../../components/Dialog/UsersDialog/UsersDialog';
import useTitle from 'hooks/useTitle';
import { CircularProgress } from '@material-ui/core';
import useValidator from 'hooks/useValidator';
import { TYPES } from 'hooks/useValidator';

const useStyles = makeStyles((theme) => ({
  toggleButton: {},
  divider: {
    margin: theme.spacing(1, 0),
  },
  editButton: {
    padding: theme.spacing(1, 4),
  },
  orderDate: {
    color: theme.palette.secondary.light,
    marginLeft: 15,
  },
  price: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    '& > *': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  insurance: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const EditOrder = ({ order, refresh }) => {
  useTitle('ویرایش سفارش');
  const validators = {
    value: [{ type: TYPES.REQUIRED }],
  };
  const [errors, validate] = useValidator(validators);
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
    showMessage,
    showError,
  } = useContext(MainContext);
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const [values, setValues] = useState({
    unloadTime: 'nodiffer',
    payType: 'atDestination',
    waybillType: 'software',
  });
  const { value } = values;
  const [addressDialog, setAddressDialog] = useState({
    open: false,
    type: null,
  });
  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [weightDialog, setWeightDialog] = useState(false);
  const [operatorDialog, setOperatorDialog] = useState(false);
  const location = useLocation();
  const [progress, setProgress] = useState(false);
  let timeout = useRef();
  const [insurance, setInsurance] = useState(0);

  const handleSelect = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    let numberFields = [
      'lengthh',
      'height',
      'width',
      'value',
      'quantity',
      'workers',
      'fleetCount',
      'proposedPrice',
    ];
    numberFields.includes(name) && (value = toEN(value));
    setValues({ ...values, [name]: value });
  };
  const handleCloseSelectAddress = () => {
    setAddressDialog({ open: false, type: null });
  };
  const handleCloseAndSaveSelectAddress = ({ addressType, address = null }) => {
    setValues({
      ...values,
      [addressType]: address,
    });
    setAddressDialog({ open: false, type: null });
  };
  const handleOpenSelectAddress = (addressType) => {
    setAddressDialog({ open: true, type: addressType });
  };
  const handleToggleDatePicker = () => {
    setOpenDateDialog(!openDateDialog);
  };
  const handleEditOrder = async () => {
    const {
      type,
      quantity,
      packaging,
      value,
      load,
      workers,
      loadTime,
      loadDate,
      origin,
      destination,
      unloadTime,
      fleetOptions,
      fleetCount,
      description,
      weight,
      weightType,
      payType,
      waybillType,
      proposedPrice,
      basePrice,
      weighbridge,
      description2,
    } = values;
    let data = {
      fleetCount: fleetCount,
      fleetOptions: fleetOptions.map((fl) => fl._id),
      originState: origin.city.state._id,
      destinationState: destination.city.state._id,
      origin: origin.city._id,
      destination: destination.city._id,
      unloadTime,
      loadDate,
      loadTime,
      payType,
      waybillType,
      proposedPrice,
      basePrice,
      insurance,
      weighbridge,
      description2,
      cargos: [
        {
          _id: order.cargos[0]._id,
          workers,
          loadDate,
          unloadTime,
          quantity: weight,
          description,
          value,
          loadTime,
          packaging: packaging?._id || null,
          type: type._id,
          load: load?._id || null,
          origin,
          destination,
          unit: weightType,
        },
      ],
    };
    try {
      setProgress(true);
      if (validate({ value: value })) {
        const response = await axios.put(
          `/api/v1/admin/order/${order._id}`,
          data
        );
        showMessage('سفارش ویرایش گردید');
      } else {
        throw 'فیلدهای مشخص شده را اصلاح فرمائید';
      }
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
      showError(error);
    }
    setProgress(false);
  };
  const handleChangeFleetsTF = (selection) => {
    setValues({ ...values, fleetOptions: selection });
  };
  const handleOpenWeightD = () => {
    setWeightDialog(true);
  };
  const handleCloseWD = (obj) => {
    setWeightDialog(false);
    setValues({ ...values, ...obj });
  };
  const handleDeleteFromTelegram = async (orderId, messageId) => {
    try {
      const { data } = await axios.post(
        `/api/v1/admin/orders/deleteTelegramPost`,
        {
          orderId,
          messageId,
        }
      );
      if (data?.ok) {
        showMessage(data?.messages);
        window.location.reload();
      }
    } catch (error) {
      showError(error);
    }
  };
  const handleChangeCB = (e) => {
    const { name, checked } = e.target;
    setValues({ ...values, [name]: checked });
  };
  const calcInsurance = async (cargoValue) => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/order/insuranceOfOrder/${cargoValue}`
      );
      if (data?.ok) {
        setInsurance(data?.insurance);
        setValues({
          ...values,
          basePrice:
            rond(values?.proposedPrice * 1 - data?.insurance) >= 0
              ? rond(values?.proposedPrice * 1 - data?.insurance)
              : 0,
        });
      }
    } catch (error) {
      showError(error);
    }
  };
  const handleChangeProposedPrice = (e) => {
    let proposedPrice = toEN(e.target.value);
    let basePrice = rond(proposedPrice * 1 - (insurance || 0) * 1);
    setValues({ ...values, proposedPrice, basePrice });
  };
  const handleChangeBasePrice = (e) => {
    let basePrice = toEN(e.target.value);
    let proposedPrice = rond((insurance || 0) * 1 + basePrice * 1);
    setValues({ ...values, proposedPrice, basePrice });
  };
  const handleOpenOperatorDialog = () => {
    setOperatorDialog(true);
  };
  const handleCloseOperatorDialog = async (users) => {
    if (users) {
      const operator = users?.[0];
      try {
        const { data } = await axios.put(
          `/api/v1/admin/orders/${order._id}/changeOperator/${operator._id}`
        );
        if (data?.ok) showMessage(data?.messages);
        refresh();
      } catch (error) {
        showError('بروز خطا');
      }
    }
    setOperatorDialog(false);
  };

  useEffect(() => {
    const {
      fleetOptions,
      fleetCount,
      proposedPrice,
      insurance,
      basePrice,
      weighbridge,
      description2,
    } = order;
    insurance && setInsurance(insurance);
    const cargo = order.cargos[0];
    const {
      type,
      quantity,
      packaging,
      value,
      load,
      workers,
      loadTime,
      loadDate,
      origin,
      destination,
      unloadTime,
      description,
      unit,
    } = cargo;
    const data = {
      type,
      quantity,
      packaging,
      value,
      load,
      workers,
      loadTime,
      loadDate,
      origin,
      destination,
      unloadTime,
      fleetOptions,
      fleetCount,
      description,
      weight: quantity,
      weightType: unit,
      proposedPrice,
      description2,
      weighbridge: weighbridge ? true : false,
    };
    basePrice && (data.basePrice = basePrice);
    setValues(data);
  }, [order]);

  useEffect(() => {
    const { hash } = location;
    if (hash === '#fleets') {
      const fleets = document.getElementById('fleets');
      fleets.scrollIntoView();
    }
  }, []);

  useEffect(() => {
    if (!value) return;
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      calcInsurance(value);
    }, 1000);
  }, [value]);

  return (
    <>
      {/* {hasRule('can_manage_operators') && <UsersDialog
      single 
      role={['admin']}
      onChange={handleCloseOperatorDialog}
      open={operatorDialog}
      closeDialog={handleCloseOperatorDialog}
    />} */}
      <UsersDialog
        single
        role={['admin']}
        onChange={handleCloseOperatorDialog}
        open={operatorDialog}
        closeDialog={handleCloseOperatorDialog}
      />
      {weightDialog ? (
        <WeightDialog
          onClose={handleCloseWD}
          w={values.weight}
          wt={values.weightType}
        />
      ) : null}

      <Typography variant="h3" component="span">
        تاریخ و ساعت ایجاد سفارش:
      </Typography>
      <span className={classes.orderDate}>
        {order && moment(order.createdAt).format('jYYYY/jMM/jDD ساعت HH:mm')}
      </span>

      <Typography variant="h3" component="span" style={{ marginRight: 20 }}>
        تاریخ و ساعت آخرین ویرایش:
      </Typography>
      <span className={classes.orderDate}>
        {order && moment(order.updatedAt).format('jYYYY/jMM/jDD ساعت HH:mm')}
      </span>

      <Divider style={{ margin: '10px 0' }} />
      <div style={{ display: 'inline-block' }}>
        {order?.operator && (
          <>
            کارشناس حمل:{' '}
            {hasRule('can_manage_operators') ||
            hasRule('can_select_operator_for_order') ? (
              <Link
                to={`/protected/admin/users/admin/${order.operator._id}`}
                style={{ marginLeft: 10 }}
              >{`${order.operator?.firstName} ${order.operator?.lastName}`}</Link>
            ) : (
              <span
                style={{ marginLeft: 10 }}
              >{`${order.operator?.firstName} ${order.operator?.lastName}`}</span>
            )}
          </>
        )}
        {(hasRule('can_manage_operators') ||
          hasRule('can_select_operator_for_order')) && (
          <Button
            onClick={handleOpenOperatorDialog}
            size="small"
            variant="outlined"
            color="secondary"
          >
            تعیین کارشناس حمل
          </Button>
        )}
      </div>
      <Divider className={classes.divider} />
      <div>اطلاعات کاربر:</div>
      <BriefInfo user={order.customer} />
      <Divider className={classes.divider} />
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} md={6}>
          <Grid
            container
            direction="column"
            justify="space-between"
            alignItems="stretch"
            spacing={1}
          >
            <Grid item>
              <SelectCargo
                cargo={values.type ? values.type : null}
                onSelect={(cargo) => handleSelect('type', cargo)}
              />
            </Grid>
            {values.type && values.type.worker && (
              <Grid item>
                <TextField
                  fullWidth
                  label="تعداد کارگر"
                  variant="outlined"
                  size="small"
                  name="workers"
                  value={values.workers ? values.workers : ''}
                  onChange={handleChange}
                />
              </Grid>
            )}
            <Grid item>
              <TextField
                fullWidth
                label="وزن محموله"
                variant="outlined"
                value={
                  !!values.weight
                    ? values.weight + ' ' + __(values.weightType)
                    : ''
                }
                size="small"
                onChange={null}
                onClick={handleOpenWeightD}
              />
            </Grid>
            <Grid item>
              <SelectPackage
                pack={values?.packaging ? values.packaging : null}
                onSelect={(pack) => handleSelect('packaging', pack)}
              />
            </Grid>
            <Grid item>
              <TextField
                required={true}
                fullWidth
                label="ارزش محموله (میلیون تومان)"
                error={errors?.value || false}
                helperText={
                  errors?.value ? ' ارزش محموله را بایستی وارد نمائید' : ''
                }
                variant="outlined"
                value={values.value ? formatNumber(values.value + '') : ''}
                size="small"
                name="value"
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <SelectLoad
                load={values.load ? values.load : null}
                onSelect={(load) => handleSelect('load', load)}
              />
            </Grid>
            {values.load && values.load.isCube && (
              <Grid item>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="طول"
                      name="lengthh"
                      variant="outlined"
                      size="small"
                      value={values.lengthh ? values.lengthh : ''}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="عرض"
                      name="width"
                      variant="outlined"
                      size="small"
                      value={values.width ? values.width : ''}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="ارتفاع"
                      name="height"
                      variant="outlined"
                      size="small"
                      value={values.height ? values.height : ''}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item>
              <TextField
                fullWidth
                label="محل بارگیری"
                size="small"
                name="origin"
                variant="outlined"
                multiline
                onClick={() => handleOpenSelectAddress('origin')}
                value={`${
                  values?.origin?.city?.state?.title
                    ? `${values.origin.city.state.title}`
                    : ''
                } ${
                  values?.origin?.city?.title
                    ? `، ${values.origin.city.title}`
                    : ''
                } ${
                  values?.origin?.details
                    ? ` - آدرس: ${values.origin.details}`
                    : ''
                } ${
                  values?.origin?.transferee
                    ? ` - ${values.origin.transferee}`
                    : ''
                } ${
                  values?.origin?.mobilePhone
                    ? ` - ${values.origin.mobilePhone}`
                    : ``
                } ${
                  values?.origin?.zipcode
                    ? ` - کدپستی: ${values.origin.zipcode}`
                    : ``
                } ${
                  values?.origin?.nationalCode
                    ? ` - کدملی:${values?.origin?.nationalCode}`
                    : ``
                } ${
                  values?.origin?.companyNationalCode
                    ? ` - شناسه ملی شرکت:${values?.origin?.companyNationalCode}`
                    : ``
                }`}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                size="small"
                label="تاریخ بارگیری"
                name="loadDate"
                variant="outlined"
                onClick={handleToggleDatePicker}
                value={
                  values.loadDate && values.loadTime
                    ? `${moment(values.loadDate).format(
                        'jYYYY/jMM/jDD'
                      )} ساعت بارگیری ${__(values.loadTime)}`
                    : ''
                }
              />
            </Grid>
            <Grid item>
              <div className={classes.price}>
                <PriceWithLabel
                  rows={4}
                  fullWidth
                  variant="outlined"
                  name="basePrice"
                  value={values?.basePrice ? values?.basePrice : ''}
                  onChange={handleChangeBasePrice}
                  label="کرایه حمل"
                  position="down"
                />
                <div className={classes.insurance}>
                  <div
                    style={{ fontSize: 20, fontWeight: 900, color: 'green' }}
                  >
                    +
                  </div>
                  <div>{`${formatNumber(insurance || 0)} تومان`}</div>
                  <div
                    style={{ fontSize: 20, fontWeight: 900, color: 'green' }}
                  >
                    =
                  </div>
                </div>
                <div className={classes.total}>
                  <PriceWithLabel
                    rows={4}
                    fullWidth
                    variant="outlined"
                    name="proposedPrice"
                    value={values?.proposedPrice ? values?.proposedPrice : ''}
                    onChange={handleChangeProposedPrice}
                    label="کرایه کل"
                    position="down"
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid
            container
            direction="column"
            justify="space-between"
            alignItems="stretch"
            spacing={1}
          >
            <Grid item>
              <TextField
                fullWidth
                label="محل تخلیه"
                size="small"
                name="destination"
                variant="outlined"
                multiline
                onClick={() => handleOpenSelectAddress('destination')}
                value={`${
                  values?.destination?.city?.state?.title
                    ? `${values.destination.city.state.title}`
                    : ''
                } ${
                  values?.destination?.city?.title
                    ? `، ${values.destination.city.title}`
                    : ''
                } ${
                  values?.destination?.details
                    ? ` - آدرس: ${values.destination.details}`
                    : ''
                } ${
                  values?.destination?.transferee
                    ? ` - ${values.destination.transferee}`
                    : ''
                } ${
                  values?.destination?.mobilePhone
                    ? ` - ${values.destination.mobilePhone}`
                    : ``
                } ${
                  values?.destination?.zipcode
                    ? ` - کدپستی: ${values.destination.zipcode}`
                    : ``
                } ${
                  values?.destination?.nationalCode
                    ? ` - کدملی:${values?.destination?.nationalCode}`
                    : ``
                } ${
                  values?.destination?.companyNationalCode
                    ? ` - شناسه ملی شرکت:${values?.destination?.companyNationalCode}`
                    : ``
                }`}
              />
            </Grid>

            {Array.isArray(values.fleetOptions) ? (
              <Grid item>
                <FleetsTextField
                  weight={values.weight}
                  weightType={values.weightType}
                  onChange={handleChangeFleetsTF}
                  selection={values.fleetOptions ? values.fleetOptions : []}
                />
              </Grid>
            ) : null}

            <Grid item>
              <Grid container spacing={1}>
                <Grid item lg={8}>
                  <TextField
                    fullWidth
                    label="تعداد ناوگان"
                    value={values.fleetCount ? values.fleetCount : 1}
                    onChange={handleChange}
                    name="fleetCount"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item lg={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values?.weighbridge ? true : false}
                        onChange={handleChangeCB}
                        name="weighbridge"
                      />
                    }
                    label="باسکول دارد؟"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <TextField
                multiline
                minRows={4}
                fullWidth
                variant="outlined"
                name="description"
                value={values.description ? values.description : ''}
                onChange={handleChange}
                label="توضیحات در مورد سفارش"
              />
            </Grid>
            <Grid item>
              <TextField
                multiline
                minRows={4}
                fullWidth
                variant="filled"
                name="description2"
                value={values?.description2 ? values.description2 : ''}
                onChange={handleChange}
                label="توضیحات اپراتور"
              />
            </Grid>
            <Grid item>
              <FormLabel>زمان تخلیه</FormLabel>
              <ToggleButtonGroup
                value={!!values.unloadTime ? values.unloadTime : 'nodiffer'}
                exclusive
                name="unloadTime"
                onChange={(e, value) =>
                  setValues({ ...values, unloadTime: value })
                }
                size="small"
                style={{ marginRight: 10 }}
              >
                <ToggleButton
                  key={1}
                  value="day"
                  className={classes.toggleButton}
                >
                  روز
                </ToggleButton>
                <ToggleButton
                  key={2}
                  value="nodiffer"
                  className={classes.toggleButton}
                >
                  فرقی نمی کند
                </ToggleButton>
                <ToggleButton
                  key={3}
                  value="night"
                  className={classes.toggleButton}
                >
                  شب
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item>
              <FormLabel>نوع بارنامه</FormLabel>
              <ToggleButtonGroup
                value={!!values.waybillType ? values.waybillType : 'software'}
                exclusive
                name="waybillType"
                onChange={(e, value) =>
                  setValues({ ...values, waybillType: value })
                }
                size="small"
                style={{ marginRight: 10 }}
              >
                <ToggleButton
                  key="w1"
                  value="software"
                  className={classes.toggleButton}
                >
                  نرم‌افزار
                </ToggleButton>
                <ToggleButton
                  key="w2"
                  value="police"
                  className={classes.toggleButton}
                >
                  پلیس‌راهی
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item>
              <FormLabel>شیوه پرداخت</FormLabel>
              <ToggleButtonGroup
                value={!!values.payType ? values.payType : 'atDestination'}
                exclusive
                name="payType"
                onChange={(e, value) =>
                  setValues({ ...values, payType: value })
                }
                size="small"
                style={{ marginRight: 10 }}
              >
                <ToggleButton
                  key="p1"
                  value="atDestination"
                  className={classes.toggleButton}
                >
                  در‌مقصد
                </ToggleButton>
                <ToggleButton
                  key="p2"
                  value="withWallet"
                  className={classes.toggleButton}
                >
                  کیف‌پول
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              <Button
                onClick={handleEditOrder}
                variant="contained"
                color="secondary"
                size="medium"
                className={classes.editButton}
                disabled={progress}
                endIcon={progress ? <CircularProgress size={10} /> : <></>}
              >
                ذخیره
              </Button>
            </Grid>
            {order?.telegramMessageId && (
              <Grid item>
                <Button
                  className={classes.editButton}
                  variant="outlined"
                  size="large"
                  onClick={() =>
                    handleDeleteFromTelegram(order._id, order.telegramMessageId)
                  }
                >
                  حذف از گروه تلگرام
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" component="h2" id="fleets">
            جزئیات حسابداری:
          </Typography>
          <CommissionsDetails />
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" component="h2" id="fleets">
            ناوگان:
          </Typography>
          <Drivers order={order} />
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" component="h2">
            لاگ:
          </Typography>
          <OrderLogs order={order} />
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        {/* <Grid item xs={12}>
          <Typography variant="h2" component="h2">
            پیغام ها:
          </Typography>
          <OrderChats orderId={order._id} />
        </Grid> */}
      </Grid>

      {addressDialog.open && (
        <SelectAddress
          addressType={addressDialog.type}
          address={values[addressDialog.type]}
          onClose={handleCloseSelectAddress}
          onSave={handleCloseAndSaveSelectAddress}
          order={order}
        />
      )}
      {openDateDialog && (
        <DatePicker
          open={true}
          onClose={({ date, time }) => {
            setValues({ ...values, loadDate: date, loadTime: time });
            handleToggleDatePicker();
          }}
        />
      )}
    </>
  );
};

export default EditOrder;
